<template>
  <div class="order">
    <div class="order_nav">
      <navbar
        title="提现订单明细"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="all">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="list.length != 0"
      >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="已经是全部内容了"
          @load="onLoad"
        >
          <van-cell class="lists" v-for="(item, index) in list" :key="index">
            <div>
              <van-row>
                <van-col span="24" class="title">
                  订单编号：{{ item.ordersn }}
                  <span>商品id：{{ item.real_goods_id }}</span>
                </van-col>
                <van-col span="24" class="goods_info">
                  <div class="info_box">
                    <div class="left">
                      <img :src="item.sku_image" @error="nofind()" />
                      <p class="goods_name">{{ item.goods_name }}</p>
                      <p class="spec">
                        <span v-if="item.specification_name">规格：</span
                        >{{ item.specification_name }}
                      </p>
                    </div>
                    <div class="right">
                      <p><span>￥</span>{{ item.cost_price }}</p>
                      <p class="quantity">X{{ item.goods_quantity }}</p>
                    </div>
                  </div>
                  <p class="money">完成时间：{{ item.confirm_time }}</p>
                  <p class="money postage">运费：￥{{ item.goods_postage }}</p>
                  <p class="account">
                    合计金额：<span>￥{{ item.goods_amount }}</span>
                  </p>
                </van-col>
              </van-row>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>

      <van-row class="empty" v-if="list.length == 0 && !hasList">
        <van-col class="emptyMsg" span="24">
          <img src="../../../assets/purchaseSupplier/common/no_info.png" />
          <p class="tip">无内容</p>
        </van-col>
      </van-row>

      <div class="loading" v-if="list.length <= 0 && hasList">
        <img src="../../../assets/accountAgent/common/loading.gif" />
      </div>
    </div>

    <div class="countMsg">
      <p class="money">
        总金额：<span>￥{{ orderMoney }}</span>
      </p>
      <p class="date" v-if="operationTime">操作时间：{{ operationTime }}</p>
      <btn
        class="confirm_btn"
        :btntext="'确定'"
        :btnwidth="'16.5rem'"
        :height="'4.4rem'"
        :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
        :borderradius="'2.2rem'"
        :btncolor="'#fff'"
        :fontsize="'1.6rem'"
        @btnClick="submit"
      />
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
      orderMoney: "",
      operationTime: "",
    };
  },
  created() {
    this.getInfo();
    if (this.$route.query.orderMoney) {
      this.orderMoney = this.$route.query.orderMoney;
    }
    if (this.$route.query.date) {
      this.operationTime = this.$route.query.date;
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    getInfo() {
      let parm = {
        page: this.page,
        size: 10,
        order_ids: this.$route.query.orderIds,
      };
      this.$api
        .post("/onorder/member/order/supplier-order-detail", parm)
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    submit() {
      if (this.$route.query.back) {
        //发起提现
        let orderInfo = {
          orderIds: this.$route.query.orderIds,
          orderMoney: this.$route.query.orderMoney,
        };
        localStorage.setItem("selectedOrderInfo", JSON.stringify(orderInfo));
        this.$router.go(-2);
      } else {
        //提现详情
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.order {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #fff;
    z-index: 3;
  }

  .all {
    padding: 8.8rem 0 6.3rem;
    box-sizing: border-box;
    height: 100%;

    .van-pull-refresh {
      height: 100%;
      padding: 1.2rem 1.6rem 0;
      box-sizing: border-box;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;

      .lists {
        min-height: 16.9rem;
        border-radius: 0.8rem;
        background: #fff;
        margin-bottom: 1.2rem;
        padding: 0;

        .title {
          color: #333;
          font-size: 1.2rem;
          text-align: left;
          height: 4.1rem;
          line-height: 4.1rem;
          padding: 0 1.2rem 0;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;

          span {
            float: right;
          }
        }

        .goods_info {
          min-height: 12.7rem;
          font-size: 1.4rem;
          color: #333;
          padding: 1.1rem 1.6rem 1.2rem 1.2rem;
          box-sizing: border-box;
          border-bottom: solid 0.05rem #eee;

          .info_box {
            position: relative;
            min-height: 8rem;

            .left {
              min-height: 8rem;
              padding: 0 6.5rem 0 9rem;

              img {
                width: 8rem;
                height: 8rem;
                // float: left;
                position: absolute;
                left: 0;
                top: 0;
              }

              p {
                line-height: 1.8rem;
              }

              .goods_name {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                white-space: normal;
              }

              .spec {
                min-height: 2rem;
                margin: 0.6rem 0 0;
                color: #999;
                font-size: 1.2rem;
              }
            }

            .right {
              float: right;
              position: absolute;
              right: 0;
              top: 0;
              min-width: 6.5rem;
              text-align: right;

              p {
                margin-bottom: 0.2rem;
                font-size: 1.3rem;

                span {
                  font-size: 1rem;
                  color: #666;
                }
              }

              .quantity {
                font-size: 1.2rem;
                color: #999;
              }
            }
          }

          .money {
            color: #999;
            line-height: 1.2rem;
            margin-top: 0.7rem;
            font-size: 1.2rem;
          }

          .postage {
            text-align: right;
            margin-top: 0.8rem;
          }

          .account {
            line-height: 2rem;
            margin-top: 0.8rem;
            font-size: 2rem;
            text-align: right;
            color: #333;
            font-size: 1.4rem;

            span {
              color: #ff4747;
            }
          }
        }
      }
    }

    .empty {
      padding-top: 10rem;

      .emptyMsg {
        text-align: center;

        img {
          width: 16rem;
          display: inline-block;
        }

        .tip {
          color: #cccccc;
          font-size: 1.4rem;
          margin-top: 1.7rem;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }

    .loading {
      width: 100%;
      /*padding-top: 100px;*/
      text-align: center;

      img {
        width: 35%;
        margin-top: 50%;
      }
    }
  }

  .countMsg {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1rem 1.5rem 1.2rem;
    background: #fff;
    box-sizing: border-box;
    height: 6.3rem;

    .money {
      color: #333;
      font-size: 1.6rem;
      font-weight: 700;

      span {
        color: #fb6b10;
      }
    }

    .date {
      color: #999;
      font-size: 1.2rem;
      margin-top: 0.6rem;
    }

    .confirm_btn {
      position: fixed;
      bottom: 1.2rem;
      right: 1.5rem;
    }
  }
}
</style>




